module.exports = __webpack_public_path__ + "static/flags/BT-fda9787a23b9f39064eaae425bf83c7a.gif";